import history from '../../../history/history';
import interventionService from '../../../services/intervention/InterventionService';
import {captureError} from '../../../utils/log';
import {getSearchValues} from '../../../utils/search';

export const getProjects = ({organisationId, pageSize}) => {
  const getInterventionData = intervention => ({
    id: intervention.interventionId,
    role: intervention.role,
    invitingOrganisation: intervention.invitationEmitterOrganisation
  });

  return new Promise((resolve, reject) => {
    const {queryString = '', page = 0} = getSearchValues(history.location.search);

    const searchParams = [
      organisationId,
      queryString,
      page,
      pageSize
    ];

    interventionService.searchByQuery(...searchParams)
      .then(({interventions, totalCount}) => {
        const projects = [];
        // Create an array of projects with their relative interventions
        interventions.forEach(intervention => {
          const currentProject = projects.find(project => intervention.project.projectId === project.projectId);
          const interventionData = getInterventionData(intervention);

          if (currentProject) {
            // If project already added, just attach intervention to it
            currentProject.interventions.push(interventionData);
          } else {
            projects.push({
              ...intervention.project,
              interventions: [interventionData]
            });
          }
        });

        resolve({projects, totalCount});
      })
      .catch(error => {
        captureError('Error while searching for interventions', error);
        reject();
      });
  });
};
